import { ReactQrCode } from '@devmehq/react-qr-code';
import { useGetUserProfileQuery } from '../api/api';
import { appEnvironment } from './environment';

export const useQRLink = () => {
  const { data } = useGetUserProfileQuery();

  if (!data) {
    return '';
  }

  // Delegate link generation to the current theme
  return appEnvironment.theme.getQRLink(data.email);
};

export default function QRCode(props: QRCodeProps) {
  const { size } = props;

  const link = useQRLink();
  if (!link) {
    return null;
  }

  return <ReactQrCode size={size !== undefined ? size : 200} value={link} />;
}

interface QRCodeProps {
  size?: number;
}
